import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { ExperimentId } from '~~/server/experiments';
import type { Experiments } from '~~/server/constants/experimentsList';

export default defineStore('experimentsStore', () => {
  const experimentFlags = ref<Experiments>({} as Experiments);
  const experimentIds = ref<Set<ExperimentId>>(new Set());

  /**
   * Set the experiment flags and ids on SSR in ProductPage.vue
   */
  const init = (flags: Experiments, ids: ExperimentId[] = []): void => {
    experimentFlags.value = flags || {};
    experimentIds.value = new Set(ids);
  };

  return {
    experimentFlags,
    experimentIds,
    init,
  };
});
